import { Suspense } from 'react'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import DataSetAboutSkeleton from '@components/skeletons/DataSetAboutSkeleton/DataSetAboutSkeleton'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import TableSkeleton from '@components/skeletons/TableSkeleton/TableSkeleton'
import SearchData from '@components/SearchData/SearchData'
import DataExplorer from '@components/DataExplorer/DataExplorer'
import type { DataItemPayload } from 'src/types/global'
import SampleData from '@components/SampleData/SampleData'
import DataSetAbout from '@components/DataSetAbout/DataSetAbout'
import { useDataset } from '@hooks/useCatalog'

import './DataSetEditor.css'

interface DataSetEditorProps {
  selectedId: string | undefined
  onSelect: (item: DataItemPayload) => void
}

const DataSetTitle = ({ id }: { id: string }) => {
  const { dataset } = useDataset(id)
  return (
    <h1 className="ellipsis">
      <span className="icon icon-table" />
      <span>{dataset?.title}</span>
    </h1>
  )
}

export default function DataSetEditor({
  selectedId,
  onSelect
}: DataSetEditorProps) {
  return (
    <div id="dataset-editor" className={selectedId ? 'split' : ''}>
      <div className="item item-left">
        <SearchData onSelect={onSelect} />
        <DataExplorer selectedId={selectedId} onSelect={onSelect} />
      </div>
      <div className="item item-right">
        {selectedId && (
          <>
            <ErrorBoundary
              errorComponent={ErrorMessage}
              key={`about-${selectedId}`}
            >
              <Suspense fallback={<DataSetAboutSkeleton />}>
                <DataSetTitle id={selectedId} />
                <DataSetAbout id={selectedId} />
              </Suspense>
            </ErrorBoundary>
            <ErrorBoundary
              errorComponent={ErrorMessage}
              key={`sample-${selectedId}`}
            >
              <Suspense fallback={<TableSkeleton />}>
                <SampleData id={selectedId} />
              </Suspense>
            </ErrorBoundary>
          </>
        )}
      </div>
    </div>
  )
}
